import { render, staticRenderFns } from "./car_Check.vue?vue&type=template&id=0ca05786&scoped=true"
import script from "./car_Check.vue?vue&type=script&lang=js"
export * from "./car_Check.vue?vue&type=script&lang=js"
import style0 from "./car_Check.vue?vue&type=style&index=0&id=0ca05786&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca05786",
  null
  
)

export default component.exports